import { Link } from '@tanstack/react-router'
import { Coins, Loader2 } from 'lucide-react'

import { Button } from '@/components/ui/Controls'
import { cn } from '@/lib/utils/cn'
import type { CreditPackage } from '@/features/billing/plans'

export function BuyCreditsButton({
  pack,
  size = 'sm',
  className,
  onBuy,
  loading = false,
}: {
  pack?: CreditPackage
  size?: 'sm' | 'md'
  className?: string
  onBuy?: (pack: CreditPackage) => void
  loading?: boolean
}) {
  if (pack && onBuy) {
    return (
      <Button
        size={size}
        variant="primary"
        icon={loading ? Loader2 : Coins}
        disabled={loading}
        onClick={() => onBuy(pack)}
        className={cn('w-full justify-center', className)}
      >
        {loading ? 'Processing...' : `Buy ${pack.name}`}
      </Button>
    )
  }

  return (
    <Link to="/pricing" className={cn('inline-flex items-center gap-2', className)}>
      <Button size={size} icon={Coins}>
        Buy credits
      </Button>
    </Link>
  )
}
